"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Label_1 = __importDefault(require("../../atoms/typography/Label"));
const FormElement = ({ label, id, children, validationMessage, required }) => {
    return (react_1.default.createElement("div", { className: 'sm:grid sm:grid-cols-3 sm:gap-4 pt-2 sm:pt-5 flex flex-col sm:flex-row sm:items-center' },
        react_1.default.createElement(Label_1.default, { text: label, id: id, required: required }),
        react_1.default.createElement("div", { className: "mt-1 max-w-lg sm:col-span-2 sm:mt-0" }, children),
        validationMessage && (react_1.default.createElement("div", { className: "col-span-2 col-start-2 pb-1 w-full min-w-0 text-error-500 text-sm" },
            react_1.default.createElement("span", { className: "min-w-0 max-w-full min-h-0 break-all", style: { wordWrap: 'break-word' } }, validationMessage)))));
};
exports.default = FormElement;
